import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { momentParse } from '../../utils/time';
import MaterialLink from '../material-link';
import type { GroupPost } from '../../types/GroupPost';
import type { Group } from '../../types/Group';
import Markdown from '../markdown';

const useStyles = makeStyles()((theme) => ({
  meta: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: theme.palette.text.primary
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(0.5)
  },
  avatar: {
    height: 18,
    width: 18
  },
  displayName: {
    marginLeft: theme.spacing(0.5)
  },
  body: {
  },
  commentCount: {
    marginLeft: theme.spacing(0.5)
  },
}));

type Props = {
  post?: GroupPost;
  group?: Group;
};

const GroupPost = ({ post, group }: Props) => {
  const { classes } = useStyles();

  if (!post) {
    return null;
  }

  const createdAt = post ? momentParse(post.createdAt) : null;
  return (
    <div>
      <Typography variant="h3" sx={{ mt: 0 }}>
        <MaterialLink
          href={`/groups/${group.slug}/posts/${post.id}`}
        >
          {post.subject}
        </MaterialLink>
      </Typography>
      <div className={classes.body}>
        <Markdown>{post.body}</Markdown>
      </div>
      <div className={classes.meta}>
        <span>
          Posted{' '}
          <time
            dateTime={createdAt.toString()}
            title={createdAt.format('dddd, MMMM Do, YYYY h:mm a')}
          >
            <MaterialLink
              href={`/groups/${group.slug}/posts/${post.id}`}
            >
              {createdAt.fromNow()}
            </MaterialLink>
          </time>
          {' by '}
        </span>
        <span className={classes.user}>
          <MaterialLink
            href={`/people/${post.user.username}`}
          >
            <Avatar
              alt={post.user.displayName}
              src={post.user.avatar.small.url}
              className={classes.avatar}
            />
          </MaterialLink>
          <MaterialLink
            href={`/people/${post.user.username}`}
            className={classes.displayName}
          >
            {post.user.displayName}
          </MaterialLink>
        </span>
        <span className={classes.commentCount}>
          &ndash;{' '}
          <MaterialLink
            href={`/groups/${group.slug}/posts/${post.id}`}
          >
            {post.commentCount === 0 ? 'no' : post.commentCount}
            {' '}
            comment{post.commentCount !== 1 ? 's' : ''}
          </MaterialLink>
        </span>
      </div>
    </div>
  );
};

export default GroupPost;
